import { MapTo } from '@adobe/aem-react-editable-components';
import EsignDisclosureTerms, { EsignDisclosureTermsEditConfig } from './EsignDisclosureTerms';

export default MapTo('cob-corp-acquisition/components/creditonebank/esign-disclosure-terms')(EsignDisclosureTerms, EsignDisclosureTermsEditConfig);